import React, {useRef, useState} from 'react';
import {useDrag, useDrop} from "react-dnd";
import _ from 'lodash'
import {Form} from "react-bootstrap";
import Button from "react-bootstrap/Button";

const DayItem = ({
                   itemD,
                   index,
                   currentColumnName,
                   setBaseData
                 }) => {

  const ref = useRef(null);
  const [show, setShow] = useState(itemD.text.length>0)
  const changeItemColumn = (currentItem, columnName) => {
    if(currentItem.currentColumnName !== columnName){
      setBaseData(prevData=>{
        const oldArrayIndex = _.findIndex(prevData.days, {date: currentItem.currentColumnName})
        const newArrayIndex = _.findIndex(prevData.days, {date: columnName})
        const copied = structuredClone(prevData.days)
        _.remove(copied[oldArrayIndex].items, {id: currentItem.id})
        copied[newArrayIndex].items.splice(currentItem.index,0,currentItem)
        return {...prevData, days : copied}
      })
    }
  };

  const [, drop] = useDrop({
    accept: "Our first type",
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      console.log(dragIndex, hoverIndex)
      item.oldIndex = item.index
      item.index = hoverIndex;
    }
  });
  const {name, id, text, checked,checkedInfo}= itemD
  const [{ isDragging }, drag] = useDrag({
    type: "Our first type",
    item: { index, name, currentColumnName, id, text, checked,checkedInfo,  type: "Our first type" },
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      console.log(dropResult)
      if (dropResult?.name && dropResult?.name !== currentColumnName) {
        console.log('currentItem',item)
        changeItemColumn(item, dropResult.name);
      }else if(dropResult?.name){
        setBaseData(prevData=>{
          const copied = structuredClone(prevData.days)
          const needArrayIndex = _.findIndex(prevData.days, {date: item.currentColumnName})
          _.remove(copied[needArrayIndex].items, {id:item.id})
          copied[needArrayIndex].items.splice(item.index,0,item)
          return {...prevData, days : copied}
        })
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });

  const opacity = isDragging ? 0.4 : 1;

  drag(drop(ref));

  const changeInfo = (name, value) =>{
    setBaseData(prevData=>{
      const copied = structuredClone(prevData.days)
      const needArrayIndex = _.findIndex(prevData.days, {date: currentColumnName})
      const item = _.find(copied[needArrayIndex].items, {id:itemD.id})
      item[name] = value
      return {...prevData, days : copied}
    })
  }
  const removeItem = () =>{
    if(window.confirm('Вы действительно хотите удалить услугу?')){
      setBaseData(prevData => {
        const copied = structuredClone(prevData.days)
        const needArrayIndex = _.findIndex(prevData.days, {date: currentColumnName})
        _.remove(copied[needArrayIndex].items, {id: itemD.id})
        return {...prevData, days: copied}
      })
    }
  }

  return (
    <div ref={ref} className="bg-secondary p-3 mb-2"
         style={{
           opacity, borderRadius: 10
         }}>
      <div className={'d-flex justify-content-between align-items-center gap-2'}>
        <div className={'d-flex gap-1 align-items-center'}>
          <i className="la la-times pointer" onClick={removeItem}/>
          <div contentEditable
               suppressContentEditableWarning
               className={'bg-body-tertiary p-2'}
               style={{ fontWeight:'Bold', minWidth:'25rem', borderRadius:5, resize:'both'}}
               onBlur={(e) => changeInfo('name',e.currentTarget.textContent)}>
            {itemD.name}
          </div>
        </div>

        <div className={'d-flex align-items-center gap-2'}>
          <Button variant={itemD.checked ? 'success' : 'danger'}
                  onClick={()=> changeInfo('checked',!itemD.checked)}>
            {itemD.checked ? 'Проверели' : 'Не проверили'}
          </Button>
          <Button variant={'outline-secondary'}
                  onClick={() => {
                    setShow(!show)
                  }}>
            <i className="fa fa-chevron-down ml-2"/>
          </Button>

        </div>
      </div>
      {show && <div className={'pt-2'}>
        <div contentEditable as={"textarea"}
             suppressContentEditableWarning
             className={'bg-body-tertiary p-2'}
             style={{fontWeight: 'Bold', width: '100%', borderRadius: 5, resize:'both'}}
             onBlur={(e) => changeInfo('text', e.currentTarget.textContent)}>
          {itemD.text}
        </div>
        {itemD.checkedInfo && <div className={'text-end'}>{itemD.checkedInfo}</div>}
      </div>}

    </div>
  );
};

export default DayItem;


